var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataCompanyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90299 5.16667V12.6667M6.23633 5.16667V12.6667M11.2363 5.16667V12.6667M14.5697 5.16667V12.6667M16.2363 16V15.3333C16.2363 14.3999 16.2363 13.9332 16.0547 13.5767C15.8949 13.2631 15.6399 13.0081 15.3263 12.8483C14.9698 12.6667 14.5031 12.6667 13.5697 12.6667H3.90299C2.96957 12.6667 2.50286 12.6667 2.14634 12.8483C1.83274 13.0081 1.57777 13.2631 1.41798 13.5767C1.23633 13.9332 1.23633 14.3999 1.23633 15.3333V16H16.2363ZM1.23633 3.08333V5.16667H16.2363V3.08333L8.73633 1L1.23633 3.08333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataCompanyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataCompanyIcon.c9335f6cb4384fe93389317cf8f0476f.svg";